import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    console.log('Newsletter subscription:', email);
    setEmail('');
  };

  return (
    <section className="contact section" id="contact">
      <div className="contact-background">
        <div className="contact-overlay"></div>
      </div>
      <div className="container">
        <div className="contact-content">
          <div className="consultation-section">
            <p className="consultation-label">CONSULTATION</p>
            <h2>Codes AI LET'S CONSULTATION</h2>
            <h3>Let's Talk About Business Solutions With Us</h3>
            <button className="btn btn-primary">Contact Us</button>
          </div>

          <div className="newsletter-section">
            <h3>News Subscription</h3>
            <p>Get Latest Deals from Codes AI Inbox & Subscribe Now</p>
            <form onSubmit={handleSubmit} className="newsletter-form">
              <div className="form-group">
                <input
                  type="email"
                  placeholder="Enter your email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <button type="submit" className="btn btn-primary">Subscribe</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
